<template>
    <div>
        <v-container>
            <!-- Selector de Año -->
            <v-select v-model="año" :items="años" label="Seleccione un año"
                @change="loadDisabledDays"></v-select>

            <v-select v-model="semestre" :items="semestres" item-value="id" item-text="nombre" label="Seleccione un semestre"
                @change="loadDisabledDays"></v-select>

            <!-- Calendario -->
            <v-row dense v-if="año">
                <v-col cols="12" md="6" lg="3" v-for="(mes, index) in meses" :key="index"  v-if="mes.semestre == semestre">
                    <v-card>
                        <v-card-title>{{ mes.mes }}</v-card-title>
                        <v-divider></v-divider>
                        <v-sheet>
                            <table class="calendar-table">
                                <thead>
                                    <tr>
                                        <th v-for="(weekday, index) in diaSemana" :key="'weekday-' + index">{{ weekday }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(week, weekIndex) in getWeeksInMonth(index + 1, año)"
                                    :key="'week-' + weekIndex">
                                        <td v-for="(day, dayIndex) in week" :key="dayIndex" class="day"
                                            :class="{ disabled: isDayDisabled(day), empty: !day }"
                                            @click="day && toggleDay(day)">
                                            {{ day ? day.split('-')[2] : '' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-sheet>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Planificador from "../../services/Planificador.service"
export default {
    data() {
        return {
            año: null,
            semestre: null,
            años: [2024,2025,2026,2027,2028,2029],
            semestres: [{id:1,nombre:"Primer Semestre"},{id:2,nombre:"Segundo Semestre"}],
            meses: [
                {mes:"Enero",semestre:1},
                {mes:"Febrero",semestre:1},
                {mes:"Marzo",semestre:1},
                {mes:"Abril",semestre:1},
                {mes:"Mayo",semestre:1},
                {mes:"Junio",semestre:1},
                {mes:"Julio",semestre:2},
                {mes:"Agosto",semestre:2},
                {mes:"Septiembre",semestre:2},
                {mes:"Octubre",semestre:2},
                {mes:"Noviembre",semestre:2},
                {mes:"Diciembre",semestre:2},
            ],
            diaSemana: ["L", "M", "M", "J", "V", "S", "D"],
            disabledDays: [], // Días no habilitados
            loading: false,
        };
    },
    methods: {
        async loadDisabledDays() {
            this.loading = true;
            if(!this.año) return;
            try {
                const response = await Planificador.ObtenerTodo(this.año);
                
                if (response.status === 200) {
                    this.disabledDays = response.data.map(date => date.split("T")[0]);
                }
            } catch (error) {
                console.error("Error al cargar días no laborables:", error);
            } finally {
               // this.loading = false;
            }
        },
        // Generar semanas del mes
        getWeeksInMonth(month, year) {
            const firstDay = new Date(year, month - 1, 1);
            const lastDay = new Date(year, month, 0);
            const weeks = [];
            let currentWeek = Array(7).fill(null);

            // Ajustar índice para que la semana inicie en lunes
            let startIndex = (firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1);

            // Rellenar días iniciales
            for (let i = 0; i < startIndex; i++) {
                currentWeek[i] = null;
            }

            // Rellenar días del mes
            for (let day = 1; day <= lastDay.getDate(); day++) {
                const date = new Date(year, month - 1, day);
                const adjustedDay = (date.getDay() === 0 ? 6 : date.getDay() - 1);
                currentWeek[adjustedDay] = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

                // Si es domingo (final de la semana) o último día del mes, cerrar la semana
                if (adjustedDay === 6 || day === lastDay.getDate()) {
                    weeks.push(currentWeek);
                    currentWeek = Array(7).fill(null);
                }
            }

            return weeks;
        },
        // Verifica si un día está deshabilitado
        isDayDisabled(day) {
            return this.disabledDays.includes(day);
        },
        // Alterna el estado de un día
        async toggleDay(day) {
            const date = day;
            ///this.loading = true; // Muestra indicador
            try {
                // Lógica para habilitar/deshabilitar días
                const response = await Planificador.novedadDia({
                    dia: date,
                });
                if (response.status === 200) {
                    this.loadDisabledDays();
                }
            } catch (error) {
                console.error("Error al actualizar día:", error);
            } finally {
                //this.loading = false; // Oculta indicador
            }
        },

    },
    mounted() {
        this.año = new Date().getFullYear()
        this.semestre = (new Date().getMonth()<7) ? 1 : 2;
        this.loadDisabledDays();

    },
};
</script>

<style>
.calendar-table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}

.calendar-table th,
.calendar-table td {
    border: 1px solid #ddd;
    width: 14.2%;
    /* 7 columnas */
    height: 50px;
    cursor: pointer;
}

.calendar-table td.empty {
    background-color: #f5f5f5;
    cursor: default;
}

.calendar-table td:hover {
    background-color: #cce5ff;
}

.calendar-table td.disabled {
    background-color: #f8d7da;
    color: #721c24;
}
</style>